import React, { ChangeEvent, FC } from "react";
import {
  AutocompleteRenderInputParams,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { FastField, useField, useFormikContext } from "formik";
import Autocomplete from "@mui/material/Autocomplete";

interface AutocompleteField {
  id?: string;
  fieldname: string;
  options?: unknown[];
  value?: unknown;
  onChange?: (e: ChangeEvent<{}>, value: any) => void;
  getOptionLabel?: (option: any) => string;
  renderOption?: (props: any, option: any) => JSX.Element;
  renderInput?: (params: AutocompleteRenderInputParams) => JSX.Element;
  disableClearable?: boolean;
  disabled?: boolean;
  filterOptions?: any;
}

const AutocompleteField: FC<AutocompleteField> = (props) => {
  const {
    id,
    options,
    fieldname,
    onChange,
    getOptionLabel,
    renderOption,
    renderInput,
    disableClearable,
    disabled,
    filterOptions,
  } = props;
  const [field, meta] = useField(fieldname);
  const { setFieldTouched } = useFormikContext();

  const handleBlur = (event: ChangeEvent<HTMLInputElement>) => {
    setFieldTouched(field.name, true);
  };
  return (
    <FormControl fullWidth variant="outlined">
      <FastField
        id={id}
        autoComplete={disabled ? "off" : null}
        key={field.name}
        name={fieldname}
        options={options}
        onBlur={handleBlur}
        as={Autocomplete}
        error={meta.touched && meta.error}
        onChange={onChange}
        getOptionLabel={getOptionLabel}
        renderOption={renderOption}
        renderInput={renderInput}
        filterOptions={filterOptions}
        disableClearable={disableClearable}
        {...props}
      />
      <FormHelperText error>
        {meta.touched && meta.error ? meta.error : ""}
      </FormHelperText>
    </FormControl>
  );
};

export default AutocompleteField;
